import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`
    .ant-modal-title {
        text-align: center;
        color: #73217D;
    }
    
    .ant-modal-content {
        text-align: center;
    }

    .ant-modal-footer {
        text-align: center;

        .ant-btn-default {
            display: none !important;
        }
    }
`;

const SuccessModal = ({
    open,
    onOk,
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            open={open}
            width={350}
            title={t("common.success")}
            okText={t("common.ok")}
            onOk={onOk}
        >
            {t("wallet.proceedTopUpSuccessModalLabel")}
        </Modal>
    );
}

export default SuccessModal;